import {Component, OnDestroy, ViewChild, OnInit, ComponentFactoryResolver} from '@angular/core';
import {EventInfo, eventInfoWithVariant} from '../models/event-info';
import * as moment from 'moment';
import {Four51Service} from '../four51.service';
import {NgbModal, NgbDate, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {Subscription} from 'rxjs';
import {NgbDateCustomParserFormatter} from '../dateformat';
import {AssetProofComponent} from './asset-proof.component';
import {ShipToComponent} from './ship-to.component';
import {HttpClient} from '@angular/common/http';
import {MailerMessage, MailerService} from '../mailer.service';
import {EmailInvitationService} from './assets/email-invitation.service';
import {Button, ModalComponent} from '../modal.component';
import {VoiceshotService} from './assets/voiceshot.service';
import {FacebookService} from './assets/facebook.service';
import {EventWaiverService} from './assets/event-waiver.service';
import {MembershipGiveawayEditComponent} from './membership-giveaway-edit.component';
import {MailTemplateService, MailTemplateValue} from '../mail-template.service';
import {InvitationService} from './assets/invitation.service';
import {environment} from '../../environments/environment';
import {PhysicianEmailAddrService} from '../physician-email-addr.service';
import has = Reflect.has;
import { ApiService } from '../api.service';

@Component({
  selector: 'app-event-approval',
  templateUrl: './event-approval.component.html',
  styleUrls: ['./event-approval.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
  ]
})

export class EventApprovalComponent implements OnInit, OnDestroy {

  // private masterEventInfo: EventInfo;
  // private masterLineItem;
  selectedOrder: any;
  private topic: any;
  private digitalLineItems: any;
  private primaryShipTo: any;
  private primaryShipToLineItems: any;
  private secondaryShipTo: any;
  private secondaryShipToLineItems: any;
  private selectedOrderLine: any;
  private orders: any[] = [];
  private isOrderListWaiting = false;
  private page = 1;
  private pageSize = 10;
  private subscription: Subscription;

  private eventDate: NgbDate;

  private emailMss = true;
  private emailDr = true;
  private emailStaff: boolean;
  private emailPdm: boolean;
  private emailPtm: boolean;
  private emailPdmMgt = true;
  private emailOther = false;
  private otherEmails: string;

  private primaryItemsToAdd: any[] = [];
  private secondaryItemsToAdd: any[] = [];

  public submitted = false;
  public isWholePageWaiting = false;

  private membershipGiveawaySku = 'MD.52424' // 'A678D8E2-AD56-4B10-BB5B-08142796E227';
  private isMembershipGiveaway;
  private membershipGiveawayDeliverDate;
  private membershipGiveawayComments;

  private isApprovedOrder = false;
  private existingOrderNumber: string;

  private selectedOrderPhysician: any;

  constructor(private four51Service: Four51Service, private modalService: NgbModal,
              private route: ActivatedRoute, private http: HttpClient, private mailerService: MailerService,
              private voiceshotService: VoiceshotService, private emailInvitationService: EmailInvitationService,
              private facebookService: FacebookService, private eventWaiverService: EventWaiverService,
              private mailTemplateService: MailTemplateService, 
              private invitationService: InvitationService, private physicianEmailAddrService: PhysicianEmailAddrService,
              private apiService: ApiService) {
    this.getOrders();
  }

  ngOnInit(): void {
    this.subscription = new Subscription();
    const paramMapSubscription = this.route.paramMap.subscribe(async (params: ParamMap) => {
      const orderId = params.get('orderid');
      const orderNumber = params.get('ordernumber');

      if (orderId) {
        const order = await this.apiService.getOrder(orderId).toPromise();
        this.selectOrder(order);
      } else {
        this.selectedOrder = null;
        this.selectedOrderPhysician = null;
      }

      if (orderNumber) {
        console.log('existing order number: ' + orderNumber);
        this.existingOrderNumber = orderNumber;
        this.isApprovedOrder = true;
      }
    });
    this.subscription.add(paramMapSubscription);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  reformatUtc(utcString: string, format: string): string {
    return moment(utcString).format(format);
  }

  async getOrders() {
    this.isOrderListWaiting = true;
    this.orders = await this.apiService.getPendingOrders().toPromise();
    this.orders = this.orders.filter((x: any) => x.status === 'Pending');
    this.isOrderListWaiting = false;
  }

  declineOrder(order: any) {
    const modalRef = this.modalService.open(ModalComponent);
    modalRef.componentInstance.title = 'Decline Order';
    modalRef.componentInstance.body = 'Are you sure you want to decline this request for ' + order.eventInfo.fullName + '?';
    const cancelButton: Button = {
      label: 'Cancel',
      action: '',
      isNeutral: true
    };
    const okButton: Button = {
      label: 'OK',
      action: '',
      isNeutral: false
    };
    modalRef.componentInstance.buttons = [cancelButton, okButton];
    modalRef.result
      .then(async result => {
        order.status = 'Declined';
        await this.apiService.createPendingOrder(order).toPromise();
        this.orders = this.orders.filter(x => x.id !== order.id);
      })
      .catch(reason => {
        // cancelled
      });
  }

  async selectOrder(order: any) {
    this.selectedOrder = order;
    if (this.selectedOrder && this.selectedOrder.eventInfo && this.selectedOrder.eventInfo.physicianId) {
      this.selectedOrderPhysician = await this.four51Service.getPhysicianProfile(this.selectedOrder.eventInfo.physicianId).toPromise();
      console.log(this.selectedOrderPhysician);
    }
    
    const membershipGiveawayLineItem = this.selectedOrder.order.placeOrderLines.find((x: any) => x.sku === this.membershipGiveawaySku);
    if (membershipGiveawayLineItem) {
      this.isMembershipGiveaway = true;
    } else {
      this.isMembershipGiveaway = false;
    }

    if (this.isMembershipGiveaway) {
      // console.log(this.selectedOrder);
      this.primaryShipToLineItems = this.selectedOrder.order.placeOrderLines;

      // const variant: any = await this.four51Service.getVariant('A678D8E2-AD56-4B10-BB5B-08142796E227', membershipGiveawayLineItem.assetId).toPromise();
      const variant: any = await this.apiService.getVariant(membershipGiveawayLineItem.assetId).toPromise();
      
      this.membershipGiveawayDeliverDate = variant.Specs.Date10.Value;
      const dataString = variant.Specs.data.Value;
      const data = JSON.parse(dataString);
      if (data && data.comments) {
        this.membershipGiveawayComments = data.comments;
      }
      // const address: any = await this.four51Service.getAddresses(membershipGiveawayLineItem.ShipAddressID).toPromise();
      // this.primaryShipTo = address;
      const contactParts = this.selectedOrder.order.shippingAddress.contact.split(/ (.*)/);
      const firstName = contactParts[0];
      let lastName = '';
      if (contactParts.length > 1) {
        lastName = contactParts[1];
      }
      this.primaryShipTo = {
        FirstName: firstName,
        LastName: lastName,
        CompanyName: this.selectedOrder.order.shippingAddress.company,
        AddressName: this.selectedOrder.order.shippingAddress.address1 + ' ' + this.selectedOrder.order.shippingAddress.city,
        Street1: this.selectedOrder.order.shippingAddress.address1,
        Street2: this.selectedOrder.order.shippingAddress.address2,
        City: this.selectedOrder.order.shippingAddress.city,
        State: this.selectedOrder.order.shippingAddress.state,
        Zip: this.selectedOrder.order.shippingAddress.zip,
        Phone: this.selectedOrder.order.shippingAddress.phone,
      };
    } else {
      const eventInfo = this.selectedOrder.eventInfo;
      
      for (const session of eventInfo.sessions) {
        session.eventStartTime.moment = moment(session.eventStartTime.moment);
        session.eventEndTime.moment = moment(session.eventEndTime.moment);
      }
      this.eventDate = eventInfo.sessions[0].eventDate;

      const topics: any = await this.http.get('./assets/json/topics.json').toPromise();
      this.topic = topics.find((x: any) => x.id === this.selectedOrder.eventInfo.topicId);
      this.groupLineItems();

      if (eventInfo.staffEmail && eventInfo.staffEmail.length > 0) {
        this.emailStaff = true;
      } else {
        this.emailStaff = false;
      }

      let isFullBuildUnderSix = false;
      let isFullBuildUnderFive = false;
      if (
        this.selectedOrderPhysician && 
        this.selectedOrderPhysician.PhysicianDetails && 
        this.selectedOrderPhysician.PhysicianDetails.PhysicianAccountSubtype === 'Full Build Physician'
      ) {
        if (
          this.selectedOrderPhysician.PhysicianDetails.OpeningDate
        ) {
          const openingMoment = moment(this.selectedOrderPhysician.PhysicianDetails.OpeningDate);
          if (moment().isBefore(openingMoment.clone().add(6, 'months'))) {
            isFullBuildUnderSix = true;
          }
          if (moment().isBefore(openingMoment.clone().add(5, 'months'))) {
            isFullBuildUnderFive = true;
          }
        }
      }

      if (eventInfo.ptmEmail && eventInfo.ptmEmail.length > 0) {
        if (
          eventInfo.practiceStatus.toLowerCase().replace(/-/g, ' ') === 'transition' || 
          eventInfo.practiceStatus.toLowerCase().replace(/-/g, ' ') === 'pre open' || 
          isFullBuildUnderSix
        ) {
          this.emailPtm = true;
        } else {
          this.emailPtm = false;
        }
      } else {
        this.emailPtm = false;
      }

      if (eventInfo.pdmEmail && eventInfo.pdmEmail.length > 0) {
        if (
          !isFullBuildUnderFive && (
            eventInfo.practiceStatus.toLowerCase().replace(/-/g, ' ') === 'pre open' ||
            eventInfo.practiceStatus.toLowerCase().replace(/-/g, ' ') === 'post open'
          )
        ) {
          this.emailPdm = true;
        } else {
          this.emailPdm = false;
        }
      } else {
        this.emailPdm = false;
      }
    }
  }

  async groupLineItems() {
    const contactParts = this.selectedOrder.order.shippingAddress.contact.split(/ (.*)/);
    const firstName = contactParts[0];
    let lastName = '';
    if (contactParts.length > 1) {
      lastName = contactParts[1];
    }
    this.primaryShipTo = {
      FirstName: firstName,
      LastName: lastName,
      CompanyName: this.selectedOrder.order.shippingAddress.company,
      AddressName: this.selectedOrder.order.shippingAddress.address1 + ' ' + this.selectedOrder.order.shippingAddress.city,
      Street1: this.selectedOrder.order.shippingAddress.address1,
      Street2: this.selectedOrder.order.shippingAddress.address2,
      City: this.selectedOrder.order.shippingAddress.city,
      State: this.selectedOrder.order.shippingAddress.state,
      Zip: this.selectedOrder.order.shippingAddress.zip,
      Phone: this.selectedOrder.order.shippingAddress.phone,
    };
    if (this.selectedOrder.secondOrder) {
      const secondContactParts = this.selectedOrder.order.shippingAddress.contact.split(/ (.*)/);
      const secondFirstName = secondContactParts[0];
      let secondlastName = '';
      if (secondContactParts.length > 1) {
        secondlastName = secondContactParts[1];
      }
      this.secondaryShipTo = {
        FirstName: secondFirstName,
        LastName: secondlastName,
        CompanyName: this.selectedOrder.secondOrder.shippingAddress.company,
        AddressName: this.selectedOrder.secondOrder.shippingAddress.address1 + ' ' + this.selectedOrder.secondOrder.shippingAddress.city,
        Street1: this.selectedOrder.secondOrder.shippingAddress.address1,
        Street2: this.selectedOrder.secondOrder.shippingAddress.address2,
        City: this.selectedOrder.secondOrder.shippingAddress.city,
        State: this.selectedOrder.secondOrder.shippingAddress.state,
        Zip: this.selectedOrder.secondOrder.shippingAddress.zip,
        Phone: this.selectedOrder.secondOrder.shippingAddress.phone
      };
    }
    const digitalSkus = ['MD.Invitation-DOWN', 'MD.InvitationEmail', 'MD.VoiceShot', 'MD.Facebook', 'MD.EventWaiver', 'MD.TipSheet', 'MD.TipSheetNA'];
    this.digitalLineItems = this.selectedOrder.order.placeOrderLines.filter((x: any) => digitalSkus.includes(x.sku));
    this.primaryShipToLineItems = this.selectedOrder.order.placeOrderLines.filter((x: any) => !digitalSkus.includes(x.sku));
    if (this.selectedOrder.secondOrder) {
      this.secondaryShipToLineItems = this.selectedOrder.secondOrder.placeOrderLines;
    }
    this.updateItemsToAdd();
  }

  updateItemsToAdd() {
    this.primaryItemsToAdd = [];
    let hasInvitation = false;
    // let hasAttendanceCards = false;
    let hasHandout = false;
    if (this.primaryShipToLineItems) {
      hasInvitation = this.primaryShipToLineItems.find((x: any) => x.sku === 'MD.Invitation');
      if (this.topic && this.topic.handouts && this.topic.handouts.length > 0 ) {
        hasHandout = this.primaryShipToLineItems.find((x: any) =>
          x.sku === this.topic.handouts[0].sku);
      }
    }
    if (!hasInvitation) {
      this.primaryItemsToAdd.push('Invitation');
    }
    if (this.topic && this.topic.handouts && this.topic.handouts.length > 0 && !hasHandout) {
        this.primaryItemsToAdd.push('Handouts');
    }
    if (this.secondaryShipTo) {
      this.secondaryItemsToAdd = [];
      let hasInvitationSecondary = false;
      let hasHandoutSecondary = false;
      if (this.secondaryShipToLineItems) {
        hasInvitationSecondary = this.secondaryShipToLineItems.find((x: any) => x.sku === 'MD.Invitation');
        if (this.topic && this.topic.handouts && this.topic.handouts.length > 0 ) {
          hasHandoutSecondary = this.secondaryShipToLineItems.find((x: any) => x.sku === this.topic.handouts[0]);
        }
      }
      if (!hasInvitationSecondary) {
        this.secondaryItemsToAdd.push('Invitation');
      }
      if (this.topic && this.topic.handouts && this.topic.handouts.length > 0 && !hasHandoutSecondary) {
        this.secondaryItemsToAdd.push('Handouts');
      }
    }
  }

  async onItemAdd(e, item: string, propagoOrder: any) {

    const invitationLineItem = this.selectedOrder.order.placeOrderLines.find((x: any) => x.sku === 'MD.Invitation' || x.sku === 'MD.Invitation-DOWN');
    
    switch (item) {
      case 'Invitation': {
        const orderLine: any = {
          sku: 'MD.Invitation',
          quantity: 1,
          printFile: invitationLineItem.printFile,
          assetId: invitationLineItem.assetId,
          custom03: invitationLineItem.assetId,
          productId: 'MDVIP-Invitation',
          name: 'Invitation',
        }
        propagoOrder.placeOrderLines.push(orderLine);

        break;
      }

      case 'Handouts': {
        if (this.topic && this.topic.handouts && this.topic.handouts.length > 0) {
          let quantity = this.topic.handout_quantities[0];
          if (quantity === 0 && this.topic.handout_quantities.length > 1) {
            quantity = this.topic.handout_quantities[1];
          }
          for (const handout of this.topic.handouts) {
            const orderLine: any = {
              sku: handout.sku,
              quantity: quantity,
              printFile: '',
              assetId: null,
              custom03: null,
              productId: handout.productId,
              name: handout.name,
            };
            propagoOrder.placeOrderLines.push(orderLine);
          }
        }
        break;
      }
    }

    this.groupLineItems();
  }

  async selectOrderLine(orderLine: any) {
    this.selectedOrderLine = orderLine;
    if (this.isMembershipGiveaway) {
      const product = await this.four51Service.getProduct('A678D8E2-AD56-4B10-BB5B-08142796E227').toPromise();
      // const variant = await this.four51Service.getVariant('A678D8E2-AD56-4B10-BB5B-08142796E227', this.selectedOrderLine.assetId).toPromise();
      const variant = await this.apiService.getVariant(this.selectedOrderLine.assetId).toPromise();
      const modalRef = this.modalService.open(MembershipGiveawayEditComponent,
        {size: 'xl', scrollable: true,  windowClass : 'modal-proof', backdrop: 'static'});
      const membershipGiveawayEditComponent: MembershipGiveawayEditComponent = modalRef.componentInstance;
      // membershipGiveawayEditComponent.product = this.selectedOrderLine.Product;
      // membershipGiveawayEditComponent.variant = this.selectedOrderLine.Variant;
      membershipGiveawayEditComponent.product = product;
      membershipGiveawayEditComponent.variant = variant;
      modalRef.result
        .then(result => {
          // done clicked
        })
        .catch(() => {
          // close box clicked
        });
    } else {
      const modalRef = this.modalService.open(AssetProofComponent, {size: 'xl', scrollable: true,  windowClass : 'modal-proof',
        backdrop: 'static'});
      modalRef.result
        .then(result => {
          // console.log('proof modal closed');
        })
        .catch(async (result) => {
          // console.log('proof modal cancelled');
          if (this.selectedOrderLine.sku === 'MD.Invitation-DOWN' || this.selectedOrderLine.sku === 'MD.Invitation') {
            // const variant: any = await this.four51Service.getVariant(this.selectedOrderLine.productId, this.selectedOrderLine.assetId).toPromise();
            const variant: any = await this.apiService.getVariant(this.selectedOrderLine.assetId).toPromise();
            // update all the invitations with this variant info
            [
              ...this.selectedOrder.order.placeOrderLines.filter((x: any) => x.productId === this.selectedOrderLine.productId),
              ...(this.selectedOrder.secondOrder) ? this.selectedOrder.secondOrder.placeOrderLines.filter((x: any) => x.productId === this.selectedOrderLine.productId) : []
            ].forEach((orderLine: any) => {
              orderLine.assetId = this.selectedOrderLine.assetId;
              orderLine.custom03 = this.selectedOrderLine.assetId;
              orderLine.printFile = variant.ProofUrl;
            });

            const updatedEventInfo: EventInfo = eventInfoWithVariant(variant);
            // check and update the event info
            const hasChanged = this.hasEventInfoChanged(updatedEventInfo);
    
            if (hasChanged) {
              await this.apiService.createPendingOrder(this.selectedOrder).toPromise();
              const copyDataModalRef = this.modalService.open(ModalComponent);
              copyDataModalRef.componentInstance.title = 'Apply To Other Items?';
              copyDataModalRef.componentInstance.body = 'Do you want to apply these edits to the other items in the cart?';
              const noButton: Button = {
                label: 'No',
                action: '',
                isNeutral: true
              };
              const yesButton: Button = {
                label: 'Yes',
                action: '',
                isNeutral: false
              };
              copyDataModalRef.componentInstance.buttons = [noButton, yesButton];
              copyDataModalRef.result
                .then(async copyDataResult => {
                  // yes pressed
                  this.updateNonInvitationLineItems();
                })
                .catch(reason => {
                  // no pressed
                });
            }
          }
          if (this.selectedOrderLine.sku === 'MD.InvitationEmail') {
            // update the rsvp online for the invite and master
            // const variant: any = await this.four51Service.getVariant(this.selectedOrderLine.productId, this.selectedOrderLine.assetId).toPromise();
            const variant: any = await this.apiService.getVariant(this.selectedOrderLine.assetId).toPromise();
            
            const dataString = (variant.Specs.data) ? variant.Specs.data.Value : '{}';
            const data = JSON.parse(dataString);
            const rsvpOnline: boolean = data.rsvpOnline;
            if (rsvpOnline !== this.selectedOrder.eventInfo.rsvpOnline) {
              this.selectedOrder.eventInfo.rsvpOnline = rsvpOnline;
              await this.apiService.createPendingOrder(this.selectedOrder).toPromise();
            }
          }


        });
      modalRef.componentInstance.orderLine = this.selectedOrderLine;
    }
  }

  hasEventInfoChanged(updatedEventInfo: EventInfo): boolean {
    let hasChanged = false;
    for (const key in updatedEventInfo) {
      if (this.selectedOrder.eventInfo.hasOwnProperty(key)) {
        if (key === 'sessions') {
          if (updatedEventInfo.sessions.length !== this.selectedOrder.eventInfo.sessions.length) {
            this.selectedOrder.eventInfo.sessions = updatedEventInfo.sessions;
            console.log(`updated sessions`);
            hasChanged = true;
          } else {
            for (let i = 0; i < updatedEventInfo.sessions.length; i++) {
              const updatedEventInfoSession: any = updatedEventInfo.sessions[i];
              const eventInfoSession: any = this.selectedOrder.eventInfo.sessions[i];
              if (
                !(updatedEventInfoSession.eventStartTime.moment.isSame(eventInfoSession.eventStartTime.moment)) ||
                !(updatedEventInfoSession.eventEndTime.moment.isSame(eventInfoSession.eventEndTime.moment)) ||
                updatedEventInfoSession.timeZone !== eventInfoSession.timeZone ||
                updatedEventInfoSession.eventDate.month !== eventInfoSession.eventDate.month ||
                updatedEventInfoSession.eventDate.year !== eventInfoSession.eventDate.year ||
                updatedEventInfoSession.eventDate.day !== eventInfoSession.eventDate.day
              ) {
                this.selectedOrder.eventInfo.sessions = updatedEventInfo.sessions;
                console.log(`updated sessions`);
                hasChanged = true;
                break;
              }
            }
          }
        } else {
          if (updatedEventInfo[key] !== this.selectedOrder.eventInfo[key]) {
            this.selectedOrder.eventInfo[key] = updatedEventInfo[key];
            console.log(`updated ${key}`);
            hasChanged = true;
          }
        }
      }
    }
    return hasChanged;
  }

  async updateNonInvitationLineItems() {
    const nonInvitationLineItems = this.selectedOrder.order.placeOrderLines
      .filter((x: any) => x.sku !== 'MD.Invitation' && x.sku !== 'MD.Invitation-DOWN');
    const eventInfo = this.selectedOrder.eventInfo;
    for (const nonInvitationLineItem of nonInvitationLineItems) {
      let variant;
      let updatedVariant;
      switch (nonInvitationLineItem.sku) {
        case 'MD.InvitationEmail': {
          // variant = await this.four51Service.getVariant(nonInvitationLineItem.productId, nonInvitationLineItem.assetId).toPromise();
          variant = await this.apiService.getVariant(nonInvitationLineItem.assetId).toPromise();
          updatedVariant = await this.emailInvitationService.refresh(variant, eventInfo);
          break;
        }
        case 'MD.VoiceShot': {
          // variant = await this.four51Service.getVariant(nonInvitationLineItem.productId, nonInvitationLineItem.assetId).toPromise();
          variant = await this.apiService.getVariant(nonInvitationLineItem.assetId).toPromise();
          updatedVariant = await this.voiceshotService.refresh(variant, eventInfo, false, false);
          break;
        }
        case 'MD.Facebook': {
          // variant = await this.four51Service.getVariant(nonInvitationLineItem.productId, nonInvitationLineItem.assetId).toPromise();
          variant = await this.apiService.getVariant(nonInvitationLineItem.assetId).toPromise();
          updatedVariant = await this.facebookService.refresh(variant, eventInfo, false, false);
          break;
        }
        case 'MDVIP-EventWaiver': {
          // variant = await this.four51Service.getVariant(nonInvitationLineItem.productId, nonInvitationLineItem.assetId).toPromise();
          variant = await this.apiService.getVariant(nonInvitationLineItem.assetId).toPromise();
          updatedVariant = await this.eventWaiverService.refresh(variant, eventInfo, false, false);
          break;
        }
      }
    }
  }

  async editAddress(address) {
    const modalRef = this.modalService.open(ShipToComponent, {size: 'xl', scrollable: true, backdrop: 'static'});
    modalRef.result
      .then(result => {
        Object.assign(address, result);
        address.IsCustEditable = true;
        address.IsShipping = true;
        address.AddressName = address.Street1 + ' ' + address.City;
        // this.four51Service.createAddress(result).toPromise()
        //   .then(res => {
        //     // console.log(res);
        //   });
      })
      .catch(result => {
        // console.log('ship to modal cancelled');
      });
    const modal: ShipToComponent = modalRef.componentInstance;
    if (address === this.primaryShipTo && !address.Zip) {
      // lazy load primary ship to
      address = this.primaryShipTo;
      // TODO update order shipping address
    }
    modalRef.componentInstance.shipAddress = Object.assign({}, address);
  }



  async removeOrderLine(orderLine: any) {
    // const response = await this.four51Service.deleteOrder(this.selectedOrderId, lineItem.ID).toPromise();
    // this.selectedOrder.LineItems = this.selectedOrder.LineItems.filter(x => x.ID !== lineItem.ID);
    // this.primaryShipToLineItems = this.primaryShipToLineItems.filter(x => x.ID !== lineItem.ID);
    // if (this.secondaryShipTo) {
    //   this.secondaryShipToLineItems = this.secondaryShipToLineItems.filter(x => x.ID !== lineItem.ID);
    //   if (this.secondaryShipToLineItems.length === 0) {
    //     this.secondaryShipTo = null;
    //     this.masterEventInfo.secondShipToAddress = false;
    //     this.masterEventInfo.secondShippingAddressID = '';
    //     this.saveMasterEventInfo();
    //   }
    // }
    this.updateItemsToAdd();
  }

  async updateQuantities() {
    for (const lineItem of this.selectedOrder.LineItems) {
      lineItem.LineTotal = lineItem.UnitPrice * lineItem.Quantity;
    }
    // const response = await this.four51Service.createOrUpdateOrder(this.selectedOrder).toPromise();
  }

  async saveEmailEventInfo() {
    const emailLineItems = this.selectedOrder.LineItems.filter(x => x.Product.InteropID === 'MDVIP-InvitationEmail');
    if (emailLineItems.length > 0) {
      const emailLineItem = emailLineItems[0];
      const dataString = (emailLineItem.Variant.Specs.data) ? emailLineItem.Variant.Specs.data.Value : '{}';
      const data = JSON.parse(dataString);
      data.rsvpOnline = this.selectedOrder.eventInfo.rsvpOnline;
      emailLineItem.Variant.Specs.data.Value = JSON.stringify(data);
      this.apiService.createVariant(emailLineItem.Variant).toPromise().then(result => {
        // console.log(result);
      });
      // this.four51Service.createVariant(emailLineItem.Variant).toPromise().then(result => {
      //   // console.log(result);
      // });
    }
  }

  async approveOrder() {
    this.isWholePageWaiting = true;

    let orderNumber: string;

    if (this.isApprovedOrder) {
      const emailOrderLine = this.selectedOrder.order.placeOrderLines.find((x: any) => x.sku === 'MD.InvitationEmail');
      // const emailVariant = await this.four51Service.getVariant('MDVIP-InvitationEmail', emailOrderLine.assetId).toPromise();
      const emailVariant = await this.apiService.getVariant(emailOrderLine.assetId).toPromise();
      let practiceStatus = null;
      if (this.selectedOrder && this.selectedOrder.eventInfo && this.selectedOrder.eventInfo.practiceStatus) {
        practiceStatus = this.selectedOrder.eventInfo.practiceStatus;
      }
      const emailHtml = await this.emailInvitationService.getHtml(emailVariant, null, practiceStatus);
      
      this.sendEmails(this.selectedOrder.order, emailHtml, this.existingOrderNumber);
    } else {
      // update the production PDFs

      if (this.isMembershipGiveaway) {
        const membershipGiveawayLineItem = this.selectedOrder.order.placeOrderLines.find((x: any) => x.sku === this.membershipGiveawaySku);
        const variant: any = await this.apiService.getVariant(membershipGiveawayLineItem.assetId).toPromise();
        const templateData = {};
        for (var key in variant.Specs) {
          if (variant.Specs.hasOwnProperty(key)) {
            templateData[key] = variant.Specs[key].Value;
          }
        }

        const body = {
            templateUrl: 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/md-52424.html',
            data: templateData,
            width: 5.5,
            height: 8
        };

        const pdfResponse = await this.apiService.getPdf(body).toPromise();
        variant.ProofUrl = pdfResponse.url;
        await this.apiService.createVariant(variant).toPromise();
        membershipGiveawayLineItem.printFile = pdfResponse.url;
        // console.log(pdfResponse.url);
        // return;
    
      } else {
        const primaryAndSecondaryLineItems = [
          ...this.selectedOrder.order.placeOrderLines,
          ...(this.selectedOrder.secondOrder) ? this.selectedOrder.secondOrder.placeOrderLines : []
        ].filter((x: any) => ['MD.Invitation', 'MD.Invitation-DOWN', 'MD.VoiceShot', 'MD.Facebook', 'MD.EventWaiver'].includes(x.sku));

        const updatedLines = [];
        for (const lineItem of primaryAndSecondaryLineItems) {
          const updatedLine: any = updatedLines.find(x => x.assetId === lineItem.assetId);
          if (updatedLine) {
            lineItem.printFile = updatedLine.printFile;
          } else {
            const variant: any = await this.apiService.getVariant(lineItem.assetId).toPromise();
            const updatedEventInfo: EventInfo = eventInfoWithVariant(variant);
            let updatedVariant: any;
            switch (lineItem.sku) {
              case 'MD.Invitation':
              case 'MD.Invitation-DOWN': {
                updatedVariant = await this.invitationService.refresh(variant, updatedEventInfo, false, true);
                break;
              }
              case 'MD.VoiceShot': {
                updatedVariant = await this.voiceshotService.refresh(variant, updatedEventInfo, false, true);
                break;
              }
              case 'MD.Facebook': {
                updatedVariant = await this.facebookService.refresh(variant, updatedEventInfo, false, true);
                break;
              }
              case 'MD.EventWaiver': {
                updatedVariant = await this.eventWaiverService.refresh(variant, updatedEventInfo, false, true);
              }
            }
            if (updatedVariant) {
              lineItem.printFile = updatedVariant.ProofUrl;
              updatedLines.push(lineItem);
            }
          }
        }
        // console.log(primaryAndSecondaryLineItems);
        // await this.apiService.createPendingOrder(this.selectedOrder).toPromise();
        // return
      }
      

      this.selectedOrder.order.desiredShipDate = moment().add(1,'d').startOf('d').format('YYYY-MM-DDThh:mm:ssZ');
      const orderResponse = await this.apiService.createOrder(this.selectedOrder.order).toPromise();
      this.isWholePageWaiting = true;
      if (orderResponse && !orderResponse.error && orderResponse.results) {
        orderNumber = orderResponse.results;
        if (this.selectedOrder.secondOrder) {
          this.selectedOrder.secondOrder.desiredShipDate = moment().add(1,'d').startOf('d').format('YYYY-MM-DDThh:mm:ssZ');
          const secondOrderResponse = await this.apiService.createOrder(this.selectedOrder.secondOrder).toPromise();
        }
        this.selectedOrder.status = 'Approved';
        this.selectedOrder.orderNumber = orderNumber;
        await this.apiService.createPendingOrder(this.selectedOrder).toPromise();
        let emailHtml = '';
        if (!this.isMembershipGiveaway) {
          const emailOrderLine = this.selectedOrder.order.placeOrderLines.find((x: any) => x.sku === 'MD.InvitationEmail');
          // const emailVariant = await this.four51Service.getVariant('MDVIP-InvitationEmail', emailOrderLine.assetId).toPromise();
          const emailVariant = await this.apiService.getVariant(emailOrderLine.assetId).toPromise();
          let practiceStatus = null;
          if (this.selectedOrder && this.selectedOrder.eventInfo && this.selectedOrder.eventInfo.practiceStatus) {
            practiceStatus = this.selectedOrder.eventInfo.practiceStatus;
          }
          emailHtml = await this.emailInvitationService.getHtml(emailVariant, null, practiceStatus);
        }
        this.sendEmails(this.selectedOrder.order, emailHtml, orderNumber);
        if (!this.isMembershipGiveaway) {
          await this.createCampaign(this.selectedOrder.order, emailHtml);
        }
      }
    }
  }

  async createCampaign(propagoOrder: any, emailHtml: string) {
    // PatientType valid values are Member, Prospect, Past Patient or Both
    const eventInfo = this.selectedOrder.eventInfo;
    let PatientType = 'Member'; // If Invite Recent Prospects = No && Invite Former Patients = No, Type = Member
    if (eventInfo.eligibleProspects === 'yes') {
      if (eventInfo.pastPatients === 'yes') {
        PatientType = 'Both'; // If Invite Recent Prospects = Yes && Invite Former Patients = Yes, Type = Both
      } else {
        PatientType = 'Prospect'; // If Invite Recent Prospects = Yes && Invite Former Patients = No, Type = Prospect
      }
    } else {
      if (eventInfo.pastPatients === 'yes') {
        PatientType = 'Past Patient'; // If Invite Recent Prospects = No && Invite Former Patients = Yes, Type = Past Patient
      }
    }

    const eventTimeZone = eventInfo.sessions[0].eventStartTime.timeZone;
    const eventDateMoment = moment(this.ngbDateToString(eventInfo.sessions[0].eventDate), 'YYYY-MM-DD');
    const EventBeginTime = eventDateMoment.format('MM/DD/YYYY') + ' ' +
    eventInfo.sessions[0].eventStartTime.moment.tz(eventTimeZone).format('hh:mm A');
    let EventEndTime = '';
    if (eventInfo.sessions[0].includeEventEndTime) {
      EventEndTime = eventDateMoment.format('MM/DD/YYYY') + ' ' +
      eventInfo.sessions[0].eventEndTime.moment.tz(eventTimeZone).format('hh:mm A');
    }
    const CampaignName = eventInfo.fullName + ' - ' + eventInfo.title.substring(0, 25) + ' - ' + eventDateMoment.format('MM/DD/YYYY');
    // const CampaignName = eventInfo.fullName + ' - ' + eventInfo.title + ' - ' + eventDateMoment.format('MM/DD/YYYY');

    const EmailHTML = emailHtml;
    let VenueAddress = eventInfo.venue_address_1;
    if (eventInfo.venue_address_2) {
      VenueAddress += ', ' + eventInfo.venue_address_2;
    }
    const data = {
      PatientType,
      AccountId: eventInfo.physicianId,
      EventBeginTime,
      EventEndTime,
      CampaignName,
      EmailHTML,
      VenueName: eventInfo.venue_name,
      VenueAddress,
      VenueCity: eventInfo.venue_city,
      VenueState: eventInfo.venue_state,
      VenueZipCode: eventInfo.venue_zip,
      VenueEventPhone: eventInfo.rsvp_phone.replace('.', ''),
      VenueRoomCapacity: +eventInfo.roomCapacity || 0
    };
    console.log(data)
    const createCampaignResponse = await this.four51Service.createCampaign(data).toPromise();
    console.log(createCampaignResponse);
  }

  async sendEmails(propagoOrder: any, emailHtml: string, orderNumber: string) {
    const eventInfo = this.selectedOrder.eventInfo;
    try {
      if (this.isMembershipGiveaway) {
        /*
         * MG Approved Doctor Email
         */
        const membershipGiveawayLineItem = this.selectedOrder.order.placeOrderLines.find((x: any) => x.sku === this.membershipGiveawaySku);
        // const variant: any = await this.four51Service.getVariant('A678D8E2-AD56-4B10-BB5B-08142796E227', membershipGiveawayLineItem.assetId).toPromise();
        const variant: any = await this.apiService.getVariant(membershipGiveawayLineItem.assetId).toPromise();
      
        const fullName = variant.Specs.V03Full_Name.Value;
        const dataString = variant.Specs.data.Value;
        const data = JSON.parse(dataString);
        const mgApprovedDoctorEmail: MailerMessage = new MailerMessage();
        mgApprovedDoctorEmail.Subject = 'Your Recent Order: ' + fullName;
        mgApprovedDoctorEmail.Bcc = environment.emailBcc;
        if (!environment.production || environment.isTest) {
          mgApprovedDoctorEmail.To = environment.emailTo;
          mgApprovedDoctorEmail.Subject = 'TESTING: ' + mgApprovedDoctorEmail.Subject;
        } else {
          this.physicianEmailAddrService.setAddresses(
            mgApprovedDoctorEmail, 
            data.email, 
            data.staffEmail, 
            data.ptmEmail, 
            data.pdmEmail,
            data.practiceStatus, 
            data.relationshipStatus, 
            data.physicianStatusType,
            (this.selectedOrderPhysician && this.selectedOrderPhysician.PhysicianDetails) ? this.selectedOrderPhysician.PhysicianDetails.PhysicianAccountSubtype : null,
            (this.selectedOrderPhysician && this.selectedOrderPhysician.PhysicianDetails) ? this.selectedOrderPhysician.PhysicianDetails.OpeningDate : null
          );
        }
        mgApprovedDoctorEmail.From = 'Marketing Support Site <MarketingSupportSite@mdvip.com>';
        mgApprovedDoctorEmail.Body = 'This message requires an email client that supports HTML email.';
        const mgApprovedDoctorValues: MailTemplateValue[] = [
          {name: 'order_number', value: orderNumber}
        ];
        mgApprovedDoctorEmail.Html = await this.mailTemplateService.replaceValues(
          './assets/html/mgApprovedDoctor.html', mgApprovedDoctorValues);
        const attachments: any[] = [];
        const scholarshipFormData = await this.getBase64Data('./assets/pdf/mdvip_scholarshipform_022814.pdf');
        const attachment = {
          base64Data: scholarshipFormData,
          contentType: 'application/pdf',
          filename: 'mdvip_scholarshipform_022814.pdf'
        };
        attachments.push(attachment);
        this.mailerService.sendMessageWithLogoAndAttachments(mgApprovedDoctorEmail, attachments);

        /* const res = await fetch('./assets/pdf/mdvip_scholarshipform_022814.pdf');
        const blob = await res.blob();
        const fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          let base64Data = e.target.result;
          console.log(base64Data);
          base64Data = base64Data.replace('data:application/pdf;base64,', '');
          const attachment = {
            base64Data: base64Data,
            contentType: 'application/pdf',
            filename: 'mdvip_scholarshipform_022814.pdf'
          };
          attachments.push(attachment);
          this.mailerService.sendMessageWithLogoAndAttachments(mgApprovedDoctorEmail, attachments);
        };
        fileReader.readAsDataURL(blob);*/
      } else {
        /*
         * Event Approved Doctor Email
         */
        const eventApprovedDoctorEmail: MailerMessage = new MailerMessage();
        const eventDateMoment = moment(this.ngbDateToString(eventInfo.sessions[0].eventDate), 'YYYY-MM-DD');
        eventApprovedDoctorEmail.Subject = eventInfo.fullName + ' Event Order ' + orderNumber +
          ' has been approved';
        eventApprovedDoctorEmail.Bcc = environment.emailBcc;
        eventApprovedDoctorEmail.Bcc.push('Email Marketing <email-marketing@mdvip.com>');
        if (!environment.production || environment.isTest) {
          eventApprovedDoctorEmail.To = environment.emailTo;
          eventApprovedDoctorEmail.Subject = 'TESTING: ' + eventApprovedDoctorEmail.Subject;
        } else {
          this.physicianEmailAddrService.setAddresses(
            eventApprovedDoctorEmail,
            (this.emailDr) ? eventInfo.email : null,
            (this.emailStaff) ? eventInfo.staffEmail : null,
            (this.emailPtm) ? eventInfo.ptmEmail : null,
            (this.emailPdm) ? eventInfo.pdmEmail : null,
            eventInfo.practiceStatus,
            eventInfo.relationshipStatus,
            eventInfo.physicianStatusType,
            (this.selectedOrderPhysician && this.selectedOrderPhysician.PhysicianDetails) ? this.selectedOrderPhysician.PhysicianDetails.PhysicianAccountSubtype : null,
            (this.selectedOrderPhysician && this.selectedOrderPhysician.PhysicianDetails) ? this.selectedOrderPhysician.PhysicianDetails.OpeningDate : null
          );
        }
        if (this.emailOther && this.otherEmails.trim().length > 0) {
          const otherEmails = this.otherEmails.split(';');
          for (const otherEmail of otherEmails) {
            eventApprovedDoctorEmail.Bcc.push(otherEmail);
          }
        }
        if (eventApprovedDoctorEmail.To.length === 0) {
          eventApprovedDoctorEmail.To.push('Marketing Support Site <MarketingSupportSite@mdvip.com>');
        }
        eventApprovedDoctorEmail.From = 'Marketing Support Site <MarketingSupportSite@mdvip.com>';
        eventApprovedDoctorEmail.Body = 'This message requires an email client that supports HTML email.';
        let powerPointRowDisplay = 'none';
        let powerPointUrl = '';
        if (this.topic) {
          if (this.topic.powerpointfile && this.topic.powerpointfile.length > 0) {
            powerPointRowDisplay = 'table-row';
            if (this.topic.powerpointfile.length > 1 ) {
              powerPointUrl = 'these PowerPoint Presentation links ';
              for (let i = 0; i < this.topic.powerpointfile.length; i++) {
                const file = window.location.origin + '/assets/pptx/' + this.topic.powerpointfile[i] + '.pptx';
                powerPointUrl += '<a href="' + file + '"><span style="color:#DE6400;text-decoration:none">File ' + (i + 1) + '</span></a> ';
              }
            } else {
              const file = window.location.origin + '/assets/pptx/' + this.topic.powerpointfile[0] + '.pptx';
              powerPointUrl = 'this <a href="' + file +
                '"><span style="color:#DE6400;text-decoration:none">PowerPoint Presentation link</span></a>';
            }
          }
        }
        // const historyUrl = window.location.origin + '/history';
        const historyUrl = environment.mdvipConnectUrl;
        let proofUrl: string;
        
        const invitationLineItem = propagoOrder.placeOrderLines
          .find((x: any) => x.sku === 'MD.Invitation-DOWN');
        proofUrl = invitationLineItem.printFile;

        const eventApprovedDoctorValues: MailTemplateValue[] = [
          {name: 'order_number', value: orderNumber},
          {name: 'title', value: eventInfo.title},
          {name: 'event_date', value: eventDateMoment.format('dddd, MMMM D')},
          {name: 'invitation_url', value: proofUrl},
          {name: 'powerpoint_url', value: powerPointUrl},
          {name: 'powerpoint_row_display', value: powerPointRowDisplay},
          {name: 'history_url', value: historyUrl}
        ];
        /*eventApprovedDoctorEmail.Html = await this.mailTemplateService
          .replaceValues('./assets/html/eventApprovedDoctor.html', eventApprovedDoctorValues);*/

        // attachments Voice Shot - PDF Only, Facebook - PDF Only, MDVIP_TipSheet, Event Waiver - PDF Only
        const voiceShotLineItem = propagoOrder.placeOrderLines
          .find((x: any) => x.sku === 'MD.VoiceShot');
        // const voiceShotURL = environment.apiBaseUrl +
        //   (new URL(voiceShotLineItem.printFile))
        //     .pathname.substring(1);
        const voiceShotURL = voiceShotLineItem.printFile;
        const voiceShotName = voiceShotLineItem.name  + '.pdf';

        const facebookLineItem = propagoOrder.placeOrderLines
          .find((x: any) => x.sku === 'MD.Facebook');
        // const facebookURL = environment.apiBaseUrl +
        //   (new URL(facebookLineItem.printFile))
        //     .pathname.substring(1);
        const facebookURL = facebookLineItem.printFile;
        const facebookName = facebookLineItem.name + '.pdf';

        const eventWaiverLineItem = propagoOrder.placeOrderLines
          .find(x => x.sku === 'MD.EventWaiver');
        // const eventWaiverURL = environment.apiBaseUrl +
        //   (new URL(eventWaiverLineItem.printFile))
        //     .pathname.substring(1);
        const eventWaiverURL = eventWaiverLineItem.printFile;
        const eventWaiverName = eventWaiverLineItem.name + '.pdf';

        const tipSheetURL = './assets/pdf/MDVIP_TipSheet.pdf';
        const tipSheetName = 'MDVIP_TipSheet.pdf';
        /*const tipSheetAbsoluteURL = window.location.protocol + '//' + window.location.hostname + '/assets/pdf/MDVIP_TipSheet.pdf';
        // const tipSheetAbsoluteURL = 'https://mdvipsf.seprint.com/assets/pdf/MDVIP_TipSheet.pdf';

        eventApprovedDoctorValues.push({name: 'voiceshot_url', value: voiceShotURL});
        eventApprovedDoctorValues.push({name: 'facebook_url', value: facebookURL});
        eventApprovedDoctorValues.push({name: 'tipsheet_url', value: tipSheetAbsoluteURL});
        eventApprovedDoctorValues.push({name: 'eventwaiver_url', value: eventWaiverURL});*/
        eventApprovedDoctorEmail.Html = await this.mailTemplateService
          .replaceValues('./assets/html/eventApprovedDoctor.html', eventApprovedDoctorValues);

        let voiceShotData;
        let facebookData;
        let eventWaiverData;
        let tipSheetData;

        await Promise.all([
          this.getBase64Data(voiceShotURL).then(data => { voiceShotData = data; }),
          this.getBase64Data(facebookURL).then(data => { facebookData = data; }),
          this.getBase64Data(eventWaiverURL).then(data => { eventWaiverData = data; }),
          this.getBase64Data(tipSheetURL).then(data => { tipSheetData = data; })
        ]);

        const doctorAttachments = [
          {
            base64Data: voiceShotData,
            contentType: 'application/pdf',
            filename: voiceShotName
          },
          {
            base64Data: facebookData,
            contentType: 'application/pdf',
            filename: facebookName
          },
          {
            base64Data: eventWaiverData,
            contentType: 'application/pdf',
            filename: eventWaiverName
          },
          {
            base64Data: tipSheetData,
            contentType: 'application/pdf',
            filename: tipSheetName
          },
        ];
        // console.log(doctorAttachments);

        this.mailerService.sendMessageWithLogoAndAttachments(eventApprovedDoctorEmail, doctorAttachments);
        // this.mailerService.sendMessageWithLogo(eventApprovedDoctorEmail);

        /*
         * Event Approved Internal Email
         */
        const eventApprovedInternalEmail: MailerMessage = new MailerMessage();
        eventApprovedInternalEmail.Subject = eventInfo.fullName + ' / Marketing Support HTML Email File';
        eventApprovedInternalEmail.Bcc = environment.emailBcc;
        eventApprovedInternalEmail.Bcc.push('Email Marketing <email-marketing@mdvip.com>');
        if (!environment.production || environment.isTest) {
          eventApprovedInternalEmail.To = environment.emailTo;
          eventApprovedInternalEmail.Subject = 'TESTING: ' + eventApprovedInternalEmail.Subject;
        } else {
          eventApprovedInternalEmail.To = ['Marketing Support Site <MarketingSupportSite@mdvip.com>'];
        }
        eventApprovedInternalEmail.From = 'Marketing Support Site <MarketingSupportSite@mdvip.com>';
        eventApprovedInternalEmail.Body = 'This message requires an email client that supports HTML email.';
        let saAttention = '';
        let saAddress = '';
        let saCity = '';
        let saState = '';
        let saZip = '';
        if (eventInfo.secondShipToAddress && this.secondaryShipTo) {
          saAttention = this.secondaryShipTo.FirstName + ' ' + this.secondaryShipTo.LastName;
          saAddress = this.secondaryShipTo.Street1;
          if (this.secondaryShipTo.Street2 && this.secondaryShipTo.Street2.length > 0) {
            saAddress += '<br />' + this.secondaryShipTo.Street2;
          }
          saCity = this.secondaryShipTo.City;
          saState = this.secondaryShipTo.State;
          saZip = this.secondaryShipTo.Zip;
        }
        const eventApprovedInternalValues: MailTemplateValue[] = [
          {name: 'date_approved', value:  moment().format('MM/DD/YYYY h:mm A')},
          {name: 'title', value: eventInfo.title },
          {name: 'event_date', value:  eventDateMoment.format('dddd, MMMM D') },
          {name: 'fullname', value: eventInfo.fullName },
          {name: 'pdm_email', value: (eventInfo.pdmEmail) ? eventInfo.pdmEmail : '' },
          {name: 'ptm_email', value: (eventInfo.ptmEmail) ? eventInfo.ptmEmail : '' },
          {name: 'room_capacity', value: (eventInfo.roomCapacity) ? eventInfo.roomCapacity : '' },
          {name: 'rsvp_online', value: (eventInfo.rsvpOnline) ? 'Yes' : 'No' },
          {name: 'channel', value: eventInfo.channel },
          {name: 'practice_status', value: eventInfo.practiceStatus },
          {name: 'relationship_status', value: eventInfo.relationshipStatus },
          {name: 'physician_status_type', value: eventInfo.physicianStatusType },
          {name: 'eligible_prospects', value: this.yesNoOrNull(eventInfo.eligibleProspects) },
          {name: 'past_patients', value: this.yesNoOrNull(eventInfo.pastPatients) },
          {name: 'ship_to_second_address', value: (eventInfo.secondShipToAddress) ? 'Yes' : 'No' },
          {name: 'display_second_address', value: (eventInfo.secondShipToAddress) ? 'table-row' : 'none' },
          {name: 'sa_attention', value: saAttention },
          {name: 'sa_address', value: saAddress },
          {name: 'sa_city', value: saCity },
          {name: 'sa_state', value: saState },
          {name: 'sa_zip', value: saZip },
          {name: 'comment', value: (eventInfo.comments) ? eventInfo.comments : '' },
          {name: 'comment_name', value: (eventInfo.commentsName) ? eventInfo.commentsName : '' },
          {name: 'comment_phone', value: (eventInfo.commentsPhone) ? eventInfo.commentsName : '' },
        ];

        eventApprovedInternalEmail.Html = await this.mailTemplateService
          .replaceValues('./assets/html/eventApprovedInternal.html', eventApprovedInternalValues);


        // get HTML for attachment
        const attachments: any[] = [];
        if (emailHtml) {
          // const base64Data = btoa(unescape(encodeURIComponent(emailHtml)));
          const utf8bytes = new TextEncoder().encode(emailHtml);
          const base64Data = btoa(
            Array.from(utf8bytes, byte => String.fromCharCode(byte)).join('')
          );
          // const base64Data = btoa(html.replace(/[\u00A0-\u2666]/g, function(c) {
          //  return '&#' + c.charCodeAt(0) + ';';
          // }));
          // const base64Data = btoa('<html><head><title>Hello World</title></head><body><div>Hello World</div></body></html>');
          const attachment = {
            base64Data: base64Data,
            contentType: 'text/html; charset=UTF-8',
            filename: 'email-invitation.html'
          };
          attachments.push(attachment);
        }
        this.mailerService.sendRawMessage(eventApprovedInternalEmail, attachments);
      } // if (this.isMembershipGiveaway)
      this.isWholePageWaiting = false;
      this.submitted = true;
    } catch (error) {
      console.log(error);
      const errorEmail: MailerMessage = new MailerMessage();
      errorEmail.To = ['tom@artoftechnology.com'];
      errorEmail.From = 'MarketingSupportSite@mdvip.com';
      errorEmail.Subject = 'Event Approval Email Error';
      errorEmail.Body = error.message;
      errorEmail.Html = '<div>' + error.message + '</div>';
      this.mailerService.sendMessage(errorEmail);
      const modalRef = this.modalService.open(ModalComponent);
      modalRef.componentInstance.title = 'Error Sending Email';
      modalRef.componentInstance.body = 'The order was approved, but there was an error sending the emails. Please try again.';
      const cancelButton: Button = {
        label: 'Cancel',
        action: '',
        isNeutral: true
      };
      const okButton: Button = {
        label: 'Send Emails',
        action: '',
        isNeutral: false
      };
      modalRef.componentInstance.buttons = [cancelButton, okButton];
      modalRef.result
        .then(async result => {
          // ok pressed
          this.sendEmails(propagoOrder, emailHtml, orderNumber);
        })
        .catch(reason => {
          // cancelled
        });
    } finally {
      this.isWholePageWaiting = false;
    }
  }

  yesNoOrNull(str: string): string {
    // console.log(str);
    if (str) {
      switch (str.toLowerCase()) {
        case 'yes': {
          return 'Yes';
        }
        case 'no': {
          return 'No';
        }
      }
    }
    return 'NULL';
  }

  ngbDateToString(object: NgbDate) {
    return (object) ? object.year + '-' + object.month + '-' + object.day : '';
  }

  async getBase64Data(url) {
    const blob = await this.http.get(url, {responseType: 'blob'}).toPromise();
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
      fileReader.onerror = () => {
        fileReader.abort();
        reject(new DOMException('Problem parsing input file.'));
      };
      fileReader.onload = () => {
        let base64Data = fileReader.result.toString();
        base64Data = base64Data.replace('data:application/pdf;base64,', '');
        resolve(base64Data);
      };
      fileReader.readAsDataURL(blob);
    });
  }
}
